export const pageMetricData = [
  {
    id: '3571',
    pages: '/affiliate',
    trafficShare: 36.59,
    uniquePreviews: 520126781,
    chart: [
      {
        label: '1',
        count: 61,
      },
      {
        label: '2',
        count: 78,
      },
      {
        label: '3',
        count: 55,
      },
      {
        label: '4',
        count: 100,
      },
      {
        label: '5',
        count: 91,
      },
      {
        label: '6',
        count: 90,
      },
      {
        label: '7',
        count: 64,
      },
      {
        label: '8',
        count: 78,
      },
      {
        label: '9',
        count: 50,
      },
      {
        label: '10',
        count: 92,
      },
      {
        label: '11',
        count: 76,
      },
      {
        label: '12',
        count: 57,
      },
      {
        label: '13',
        count: 87,
      },
      {
        label: '14',
        count: 68,
      },
      {
        label: '15',
        count: 50,
      },
    ],
    createdAt: '2023-07-19T14:59:25.404Z',
    updatedAt: '2023-08-13T18:30:02.142Z',
  },
  {
    id: '6411',
    pages: '/payment-checkout',
    trafficShare: 60.35,
    uniquePreviews: 130155421,
    chart: [
      {
        label: '1',
        count: 85,
      },
      {
        label: '2',
        count: 79,
      },
      {
        label: '3',
        count: 67,
      },
      {
        label: '4',
        count: 96,
      },
      {
        label: '5',
        count: 97,
      },
      {
        label: '6',
        count: 92,
      },
      {
        label: '7',
        count: 50,
      },
      {
        label: '8',
        count: 76,
      },
      {
        label: '9',
        count: 87,
      },
      {
        label: '10',
        count: 61,
      },
      {
        label: '11',
        count: 97,
      },
      {
        label: '12',
        count: 63,
      },
      {
        label: '13',
        count: 70,
      },
      {
        label: '14',
        count: 96,
      },
      {
        label: '15',
        count: 68,
      },
    ],
    createdAt: '2023-06-25T02:40:21.865Z',
    updatedAt: '2023-08-17T09:42:36.700Z',
  },
  {
    id: '0654',
    pages: '/app/signin',
    trafficShare: 2.29,
    uniquePreviews: 610701486,
    chart: [
      {
        label: '1',
        count: 80,
      },
      {
        label: '2',
        count: 71,
      },
      {
        label: '3',
        count: 92,
      },
      {
        label: '4',
        count: 69,
      },
      {
        label: '5',
        count: 62,
      },
      {
        label: '6',
        count: 100,
      },
      {
        label: '7',
        count: 77,
      },
      {
        label: '8',
        count: 94,
      },
      {
        label: '9',
        count: 83,
      },
      {
        label: '10',
        count: 82,
      },
      {
        label: '11',
        count: 92,
      },
      {
        label: '12',
        count: 78,
      },
      {
        label: '13',
        count: 95,
      },
      {
        label: '14',
        count: 66,
      },
      {
        label: '15',
        count: 65,
      },
    ],
    createdAt: '2023-08-06T19:57:50.619Z',
    updatedAt: '2023-08-15T04:10:02.475Z',
  },
  {
    id: '5351',
    pages: '/tracking-page',
    trafficShare: 80.13,
    uniquePreviews: 763634256,
    chart: [
      {
        label: '1',
        count: 90,
      },
      {
        label: '2',
        count: 62,
      },
      {
        label: '3',
        count: 63,
      },
      {
        label: '4',
        count: 71,
      },
      {
        label: '5',
        count: 63,
      },
      {
        label: '6',
        count: 89,
      },
      {
        label: '7',
        count: 91,
      },
      {
        label: '8',
        count: 71,
      },
      {
        label: '9',
        count: 95,
      },
      {
        label: '10',
        count: 66,
      },
      {
        label: '11',
        count: 67,
      },
      {
        label: '12',
        count: 74,
      },
      {
        label: '13',
        count: 72,
      },
      {
        label: '14',
        count: 83,
      },
      {
        label: '15',
        count: 59,
      },
    ],
    createdAt: '2023-08-09T15:27:22.459Z',
    updatedAt: '2023-08-13T09:20:22.664Z',
  },
  {
    id: '1913',
    pages: '/app/ecommerce/products',
    trafficShare: 12.49,
    uniquePreviews: 373109283,
    chart: [
      {
        label: '1',
        count: 98,
      },
      {
        label: '2',
        count: 76,
      },
      {
        label: '3',
        count: 72,
      },
      {
        label: '4',
        count: 70,
      },
      {
        label: '5',
        count: 99,
      },
      {
        label: '6',
        count: 71,
      },
      {
        label: '7',
        count: 56,
      },
      {
        label: '8',
        count: 94,
      },
      {
        label: '9',
        count: 74,
      },
      {
        label: '10',
        count: 66,
      },
      {
        label: '11',
        count: 66,
      },
      {
        label: '12',
        count: 87,
      },
      {
        label: '13',
        count: 59,
      },
      {
        label: '14',
        count: 92,
      },
      {
        label: '15',
        count: 57,
      },
    ],
    createdAt: '2023-07-05T23:43:21.645Z',
    updatedAt: '2023-08-15T11:10:45.163Z',
  },
  {
    id: '6455',
    pages: '/s',
    trafficShare: 53.11,
    uniquePreviews: 638159894,
    chart: [
      {
        label: '1',
        count: 88,
      },
      {
        label: '2',
        count: 67,
      },
      {
        label: '3',
        count: 83,
      },
      {
        label: '4',
        count: 67,
      },
      {
        label: '5',
        count: 82,
      },
      {
        label: '6',
        count: 66,
      },
      {
        label: '7',
        count: 78,
      },
      {
        label: '8',
        count: 95,
      },
      {
        label: '9',
        count: 55,
      },
      {
        label: '10',
        count: 93,
      },
      {
        label: '11',
        count: 69,
      },
      {
        label: '12',
        count: 100,
      },
      {
        label: '13',
        count: 94,
      },
      {
        label: '14',
        count: 91,
      },
      {
        label: '15',
        count: 91,
      },
    ],
    createdAt: '2023-07-01T06:12:40.663Z',
    updatedAt: '2023-08-15T20:36:41.086Z',
  },
  {
    id: '6868',
    pages: '/payment-checkout',
    trafficShare: 43.94,
    uniquePreviews: 492195987,
    chart: [
      {
        label: '1',
        count: 56,
      },
      {
        label: '2',
        count: 67,
      },
      {
        label: '3',
        count: 58,
      },
      {
        label: '4',
        count: 95,
      },
      {
        label: '5',
        count: 50,
      },
      {
        label: '6',
        count: 64,
      },
      {
        label: '7',
        count: 93,
      },
      {
        label: '8',
        count: 86,
      },
      {
        label: '9',
        count: 70,
      },
      {
        label: '10',
        count: 64,
      },
      {
        label: '11',
        count: 78,
      },
      {
        label: '12',
        count: 61,
      },
      {
        label: '13',
        count: 72,
      },
      {
        label: '14',
        count: 55,
      },
      {
        label: '15',
        count: 55,
      },
    ],
    createdAt: '2023-06-21T01:23:48.379Z',
    updatedAt: '2023-08-14T06:51:06.570Z',
  },
  {
    id: '4249',
    pages: '/payment-checkout',
    trafficShare: 93.86,
    uniquePreviews: 75065789,
    chart: [
      {
        label: '1',
        count: 64,
      },
      {
        label: '2',
        count: 69,
      },
      {
        label: '3',
        count: 79,
      },
      {
        label: '4',
        count: 80,
      },
      {
        label: '5',
        count: 80,
      },
      {
        label: '6',
        count: 57,
      },
      {
        label: '7',
        count: 73,
      },
      {
        label: '8',
        count: 67,
      },
      {
        label: '9',
        count: 81,
      },
      {
        label: '10',
        count: 61,
      },
      {
        label: '11',
        count: 90,
      },
      {
        label: '12',
        count: 99,
      },
      {
        label: '13',
        count: 97,
      },
      {
        label: '14',
        count: 88,
      },
      {
        label: '15',
        count: 84,
      },
    ],
    createdAt: '2023-07-12T13:15:37.145Z',
    updatedAt: '2023-08-16T04:11:38.325Z',
  },
  {
    id: '2872',
    pages: '/app/signin',
    trafficShare: 92.84,
    uniquePreviews: 604454004,
    chart: [
      {
        label: '1',
        count: 80,
      },
      {
        label: '2',
        count: 87,
      },
      {
        label: '3',
        count: 63,
      },
      {
        label: '4',
        count: 73,
      },
      {
        label: '5',
        count: 92,
      },
      {
        label: '6',
        count: 52,
      },
      {
        label: '7',
        count: 69,
      },
      {
        label: '8',
        count: 70,
      },
      {
        label: '9',
        count: 67,
      },
      {
        label: '10',
        count: 86,
      },
      {
        label: '11',
        count: 83,
      },
      {
        label: '12',
        count: 57,
      },
      {
        label: '13',
        count: 68,
      },
      {
        label: '14',
        count: 62,
      },
      {
        label: '15',
        count: 63,
      },
    ],
    createdAt: '2023-07-10T15:22:05.363Z',
    updatedAt: '2023-08-11T23:31:57.783Z',
  },
  {
    id: '0213',
    pages: '/ecommerce-dashboard',
    trafficShare: 39.51,
    uniquePreviews: 861753839,
    chart: [
      {
        label: '1',
        count: 52,
      },
      {
        label: '2',
        count: 76,
      },
      {
        label: '3',
        count: 60,
      },
      {
        label: '4',
        count: 69,
      },
      {
        label: '5',
        count: 92,
      },
      {
        label: '6',
        count: 100,
      },
      {
        label: '7',
        count: 100,
      },
      {
        label: '8',
        count: 65,
      },
      {
        label: '9',
        count: 57,
      },
      {
        label: '10',
        count: 96,
      },
      {
        label: '11',
        count: 62,
      },
      {
        label: '12',
        count: 51,
      },
      {
        label: '13',
        count: 73,
      },
      {
        label: '14',
        count: 100,
      },
      {
        label: '15',
        count: 98,
      },
    ],
    createdAt: '2023-07-20T17:02:12.544Z',
    updatedAt: '2023-08-16T02:25:39.721Z',
  },
  {
    id: '9588',
    pages: '/app/signin',
    trafficShare: 55.4,
    uniquePreviews: 207828543,
    chart: [
      {
        label: '1',
        count: 90,
      },
      {
        label: '2',
        count: 71,
      },
      {
        label: '3',
        count: 88,
      },
      {
        label: '4',
        count: 99,
      },
      {
        label: '5',
        count: 73,
      },
      {
        label: '6',
        count: 74,
      },
      {
        label: '7',
        count: 69,
      },
      {
        label: '8',
        count: 78,
      },
      {
        label: '9',
        count: 84,
      },
      {
        label: '10',
        count: 74,
      },
      {
        label: '11',
        count: 94,
      },
      {
        label: '12',
        count: 69,
      },
      {
        label: '13',
        count: 85,
      },
      {
        label: '14',
        count: 53,
      },
      {
        label: '15',
        count: 88,
      },
    ],
    createdAt: '2023-06-29T17:27:17.356Z',
    updatedAt: '2023-08-13T12:25:27.632Z',
  },
  {
    id: '6235',
    pages: '/id/cpc',
    trafficShare: 29.46,
    uniquePreviews: 764398282,
    chart: [
      {
        label: '1',
        count: 92,
      },
      {
        label: '2',
        count: 94,
      },
      {
        label: '3',
        count: 93,
      },
      {
        label: '4',
        count: 50,
      },
      {
        label: '5',
        count: 66,
      },
      {
        label: '6',
        count: 90,
      },
      {
        label: '7',
        count: 59,
      },
      {
        label: '8',
        count: 61,
      },
      {
        label: '9',
        count: 74,
      },
      {
        label: '10',
        count: 57,
      },
      {
        label: '11',
        count: 75,
      },
      {
        label: '12',
        count: 72,
      },
      {
        label: '13',
        count: 98,
      },
      {
        label: '14',
        count: 68,
      },
      {
        label: '15',
        count: 65,
      },
    ],
    createdAt: '2023-07-13T21:59:09.901Z',
    updatedAt: '2023-08-17T00:48:10.267Z',
  },
  {
    id: '5017',
    pages: '/home',
    trafficShare: 97.36,
    uniquePreviews: 456160458,
    chart: [
      {
        label: '1',
        count: 97,
      },
      {
        label: '2',
        count: 62,
      },
      {
        label: '3',
        count: 82,
      },
      {
        label: '4',
        count: 95,
      },
      {
        label: '5',
        count: 68,
      },
      {
        label: '6',
        count: 83,
      },
      {
        label: '7',
        count: 95,
      },
      {
        label: '8',
        count: 57,
      },
      {
        label: '9',
        count: 53,
      },
      {
        label: '10',
        count: 57,
      },
      {
        label: '11',
        count: 75,
      },
      {
        label: '12',
        count: 59,
      },
      {
        label: '13',
        count: 81,
      },
      {
        label: '14',
        count: 99,
      },
      {
        label: '15',
        count: 57,
      },
    ],
    createdAt: '2023-08-04T04:19:50.574Z',
    updatedAt: '2023-08-12T03:55:47.844Z',
  },
  {
    id: '0984',
    pages: '/support/inbox',
    trafficShare: 66.98,
    uniquePreviews: 26275270,
    chart: [
      {
        label: '1',
        count: 64,
      },
      {
        label: '2',
        count: 60,
      },
      {
        label: '3',
        count: 83,
      },
      {
        label: '4',
        count: 82,
      },
      {
        label: '5',
        count: 96,
      },
      {
        label: '6',
        count: 59,
      },
      {
        label: '7',
        count: 77,
      },
      {
        label: '8',
        count: 78,
      },
      {
        label: '9',
        count: 75,
      },
      {
        label: '10',
        count: 100,
      },
      {
        label: '11',
        count: 79,
      },
      {
        label: '12',
        count: 90,
      },
      {
        label: '13',
        count: 97,
      },
      {
        label: '14',
        count: 53,
      },
      {
        label: '15',
        count: 52,
      },
    ],
    createdAt: '2023-08-03T14:47:24.959Z',
    updatedAt: '2023-08-15T11:01:29.983Z',
  },
  {
    id: '8408',
    pages: '/gp/css/order-history',
    trafficShare: 43.12,
    uniquePreviews: 37349904,
    chart: [
      {
        label: '1',
        count: 90,
      },
      {
        label: '2',
        count: 70,
      },
      {
        label: '3',
        count: 59,
      },
      {
        label: '4',
        count: 55,
      },
      {
        label: '5',
        count: 86,
      },
      {
        label: '6',
        count: 69,
      },
      {
        label: '7',
        count: 95,
      },
      {
        label: '8',
        count: 63,
      },
      {
        label: '9',
        count: 66,
      },
      {
        label: '10',
        count: 72,
      },
      {
        label: '11',
        count: 87,
      },
      {
        label: '12',
        count: 51,
      },
      {
        label: '13',
        count: 54,
      },
      {
        label: '14',
        count: 86,
      },
      {
        label: '15',
        count: 99,
      },
    ],
    createdAt: '2023-08-16T09:07:13.230Z',
    updatedAt: '2023-08-13T10:29:54.118Z',
  },
];
